module.exports = __webpack_public_path__ + "static/media/logo4-removebg-preview.a5fa80f3.png";